<template lang="">
    <v-container class="mt-7"
    style="background-color: #F9F9FC;"> 
     <v-row>
        <v-col md="12">
            <h2>Sales</h2>
            <TableuVue :width="width" :url="url[0]"/>
        </v-col>
     </v-row>
         
</v-container>
    
</template>
<script>
import TableuVue from '@/components/Tableu.vue'

export default {
    components:{
        TableuVue
    },
    data(){
        return{
            url:[],
            width:"100%",
            links:null
        }
    }, 
    methods:{
       getLinkTablue(){
            let link= this.$session.getAll().user.tableau_list
            link.forEach(x =>{
               if(x.purpose =="salesdashboard"){
                    this.url.push(x.link)         
               }
            } )
        }
    },

    mounted () {
       if (localStorage.getItem('reloaded')) {   
        localStorage.removeItem('reloaded');
    } else { 
        localStorage.setItem('reloaded', '1');
        location.reload();
    }
   
   
  },
  created(){
   this.getLinkTablue()
  }
 

}
</script>
<style scoped>
   
</style>